$(document).ready(function () {
    if ($('#orders-filters').length){
        let client_select = $("#orders-filters .of-client select");
        let market_select = $("#orders-filters .of-market select");
        let station_select = $("#orders-filters .of-station select");

        client_select.select2();
        market_select.select2();
        station_select.select2();

        new Lightpick({
            field: document.getElementById('orders-filters-start'),
            secondField: document.getElementById('orders-filters-end'),
            singleDate: false,
            format: 'MM/DD/YYYY'
        });
    }
});
